<template>
  <div class="lanaya-button-group">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'LButtonGroup'
};
</script>



// WEBPACK FOOTER //
// packages/button/ButtonGroup.vue